"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ReglementForm = _interopRequireDefault(require("./components/ReglementForm"));

var _constantes = require("@/helpers/constantes");

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
var _default = {
  // 1. Effets de bord
  // --
  // 2. Informations globales
  // --
  name: 'ReglementNew',
  // 3. Type de composant
  // --
  // 4. Modificateurs de template
  // --
  // 5. Dépendances des templates
  // --
  components: {
    ReglementForm: _ReglementForm.default
  },
  // 6. Composition
  // --
  // 7. Interface (interface du composant)
  // --
  props: {
    type_reglement: {
      type: Number,
      default: _constantes.REGLEMENTS.TYPE.PAIEMENT.value,
      validator: function validator(value) {
        return [_constantes.REGLEMENTS.TYPE.PAIEMENT.value, _constantes.REGLEMENTS.TYPE.TROP_PERCU.value].includes(value);
      }
    }
  },
  // 8. État local (propriétés réactives locales)
  // --
  data: function data() {
    return {
      action: 'new',
      formData: {
        // Pré-remplir la date de règlement avec la date du jour si non indiquée
        date_reglement: (0, _moment.default)().format('YYYY-MM-DD'),
        type: this.type_reglement,
        montant: null,
        id_affaire: null
      },
      title: 'Ajouter un règlement'
    };
  } // 9. Évènements
  // --
  // 10. Propriétés non réactives
  // --
  // 11. Rendu
  // --

};
exports.default = _default;